import ListPlace from "@/utils/presenters/ListPlace.ts";
import PlaceTokens from "@/utils/constants/PlaceTokens.ts";
import BSCEntities from "@/utils/constants/BSCEntities.ts";
import ConstantViewNames from "@/utils/constants/ConstantViewNames.ts";
import ObjectChecker from "@/utils/common/ObjectChecker.ts";

export default class ListReportPlace extends ListPlace
{
  get currentRoot(): string | undefined {
    return this.query[PlaceTokens.PRM_ROOT];
  }

  set currentRoot(value: string) {
    this.query[PlaceTokens.PRM_ROOT] = value;
  }

  get rootType(): string | undefined {
    return this.query[PlaceTokens.PRM_ROOT_TYPE];
  }

  set rootType(value: string) {
    this.query[PlaceTokens.PRM_ROOT_TYPE] = value;
  }

  override get showTree(): boolean | undefined {
    return true;
  }

  override get entityType(): string | undefined {
    return BSCEntities.ReportDefinition;
  }

  override get listViewName(): string | undefined {
    return ConstantViewNames.REPORT_CATALOGUE_SCREEN_NAME;
  }

  override set listViewName(value: string) {
    if (ObjectChecker.isEmptyOrNull(value))
      return;
    this.query[PlaceTokens.PRM_LIST_VIEW_NAME] = value;
  }
}
